/* eslint-disable no-irregular-whitespace */
// There's python code embedded below that includes non-printing characters like
// NBSP. eslint rightfully doesn't like these characters, but in this case we
// want them.
import {ReactNode} from 'react';

export enum FrameworkCategory {
  MODELS = 'models',
  LLMS = 'LLMs',
}

export enum FrameworkName {
  PYTHON_PYTORCH = 'Python/PyTorch',
  PYTORCH_LIGHTNING = 'PyTorch Lightning',
  KERAS_TENSOR_FLOW = 'Keras/TensorFlow',
  TRANSFORMERS = 'Transformers',
  XG_BOOST = 'XGBoost',
  SCIKIT_LEARN = 'Scikit-learn',
  LANGCHAIN = 'LangChain',
  OPENAI = 'OpenAI API',
  LLAMAINDEX = 'LlamaIndex',
}

export enum FrameworkPathname {
  PYTHON_PYTORCH = 'python-pytorch',
  PYTORCH_LIGHTNING = 'pytorch-lightning',
  KERAS_TENSOR_FLOW = 'keras-tensorflow',
  TRANSFORMERS = 'transformers',
  XG_BOOST = 'xgboost',
  SCIKIT_LEARN = 'scikit-learn',
  LANGCHAIN = 'langchain',
  OPENAI = 'openai',
  LLamaIndex = 'llamaindex',
}

export const FRAMEWORK_PATHNAME_MAP = new Map<FrameworkName, FrameworkPathname>(
  [
    [FrameworkName.PYTHON_PYTORCH, FrameworkPathname.PYTHON_PYTORCH],
    [FrameworkName.PYTORCH_LIGHTNING, FrameworkPathname.PYTORCH_LIGHTNING],
    [FrameworkName.KERAS_TENSOR_FLOW, FrameworkPathname.KERAS_TENSOR_FLOW],
    [FrameworkName.TRANSFORMERS, FrameworkPathname.TRANSFORMERS],
    [FrameworkName.XG_BOOST, FrameworkPathname.XG_BOOST],
    [FrameworkName.SCIKIT_LEARN, FrameworkPathname.SCIKIT_LEARN],
  ]
);

export interface Framework {
  iconWithName?: ReactNode;
  value: FrameworkName;
  codeSnippet: string;
  dataTest: string;
  pathname: FrameworkPathname;
  colabLink: string;
  frameworkCategory: FrameworkCategory;
}
